import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

export default class OutsideClick extends PureComponent {
    static propTypes = {
        onOutsideClick: PropTypes.func.isRequired,
        children: PropTypes.any.isRequired
    }

    static defaultProps = {
        className: 'flex-1'
    }

    constructor(props) {
        super(props);

        this.REF = React.createRef();
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.onOutsideClick);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.onOutsideClick);
    }

    onOutsideClick = (e) => {
        if (!this.REF.current.contains(e.target)) {
            this.props.onOutsideClick();
        }
    }

    render() {
        const { onOutsideClick, ...props } = this.props;

        return (
            <div ref={this.REF} {...props}>
                {this.props.children}
            </div>
        );
    }
}
